import BigButton from 'components/buttons/bigButton'
import React from 'react'
export default function ButtonsContainer(props) {
    const {buttons, routes, url} = props
    return (   
        <div id="buttonsContainer" className='flex center w100 wrap'>
            {
                buttons.map((button, index) => <BigButton key={index} delay={button.delay} top={button.top} left={button.left} right={button.right} title={button.title} icon={button.icon} page={button.page} background={button.buttonBackground} headbandBackground={button.headbandBackground} />)
            }
        </div>
    )
}
